<template>
  <!-- 阅读器的文本页面 -->
  <div class="edit" @mousedown="mousedownForMark">
    <img :src="url + item.fileUrl" class="read_img" />
    <template v-if="zoom === 100">
      <div
        @click="clickBz(index)"
        class="noTonch bzcss"
        :style="{
          left: bz.style.left + 'px',
          top: bz.style.top + 'px',
          width: bz.style.width + 'px',
          height: bz.style.height + 'px',
          border:
            clickIndex === index ? '4px dashed #AA1D1F' : '4px solid #AA1D1F',
        }"
        v-for="(bz, index) in bzList"
      >
        <el-tooltip
          :key="tooltipKey"
          class="noTonch"
          effect="dark"
          :disabled="bz.noteContent && zoom === 100 ? false : true"
          :content="bz.noteContent"
          placement="top-start"
        >
          <div class="noTonch" style="height: 100%; width: 100%"></div>
        </el-tooltip>
      </div>
    </template>
    <el-dialog
      append-to-body
      title="备注"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-input v-model="noteContent" placeholder="请输入备注"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRemark">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  noteAdd,
  noteEdit,
  noteDeletet
} from '@/api/note.js'
export default {
  props: ['item', 'isEdit', 'tooltipKey', 'zoom'],
  data () {
    return {
      noteContent: '',
      dialogVisible: false,
      clickIndex: '',
      bzList: [],
      url: window.__baseUrl__,
    }
  },
  mounted () {
    console.log(this.item, this.isEdit, this.tooltipKey, 'item')
    setTimeout(() => {
      this.bzList = this.item.notes
    }, 1000)
    document.addEventListener('keyup', (event) => {
      const keyName = event.key
      if (keyName === 'Backspace') {
        this.deleteItem()
      }
    })
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
      this.noteContent = ''
    },
    saveRemark () {
      if (this.bzList[this.clickIndex].noteId) {
        noteEdit({
          noteId: this.bzList[this.clickIndex].noteId,
          bookId: this.item.bookId,
          noteType: '1',
          noteTarget: '',
          noteContent: this.noteContent,
          notePage: this.item.bookPage,
          notePos: JSON.stringify(this.bzList[this.clickIndex].style),
        }).then((res) => {
          if (res.code === 200) {
            this.bzList[this.clickIndex].noteContent = this.noteContent
            this.clickIndex = ''
            this.dialogVisible = false
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        noteAdd({
          bookId: this.item.bookId,
          noteType: '1',
          noteTarget: '',
          noteContent: this.noteContent,
          notePage: this.item.bookPage,
          notePos: JSON.stringify(this.bzList[this.clickIndex].style),
        }).then((res) => {
          if (res.code === 200) {
            this.bzList[this.clickIndex].noteContent = this.noteContent
            this.clickIndex = ''
            this.dialogVisible = false
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    deleteItem () {
      if (!this.dialogVisible) {
        if (this.clickIndex !== '') {
          this.$alert('确认删除该笔记吗?', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              noteDeletet(this.bzList[this.clickIndex].noteId).then((res) => {
                if (res.code === 200) {
                  this.clickIndex = ''
                  this.$message.success('删除成功')
                  this.bzList.splice(this.clickIndex, 1)
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          })

        }
      }
    },
    clickBz (index) {
      if (this.isEdit) {
        this.clickIndex = index
        this.dialogVisible = true
        this.noteContent = this.bzList[this.clickIndex].noteContent
      }
    },
    mousedownForMark (e) {
      console.log(e)
      if (e.path[0].className.indexOf('noTonch') !== -1) {
        return
      }
      if (this.isEdit) {
        console.log(e)
        const left = e.offsetX
        const top = e.offsetY
        // 再点击位置 创建备注框
        const bzItem = {
          noteContent: '',
          style: {
            left,
            top
          }
        }
        console.log(bzItem)
        this.bzList.push(bzItem)
        const index = this.bzList.length - 1
        let startX = e.clientX
        let startY = e.clientY
        let move = moveEvent => {
          const pos = {
            ...bzItem
          }
          const width = moveEvent.clientX - startX
          const height = moveEvent.clientY - startY
          pos.style.width = width
          pos.style.height = height
          console.log(moveEvent.offsetX)
          this.$set(this.bzList, index, pos)
        }
        let up = (moveEvent) => {
          const width = moveEvent.clientX - startX
          const height = moveEvent.clientY - startY
          document.removeEventListener('mousemove', move)
          document.removeEventListener('mouseup', up)
          if (width < 5 && height < 5) {
            this.bzList.splice(index, 1)
            return
          }
          this.clickBz(index)
        }
        document.addEventListener('mousemove', move)
        document.addEventListener('mouseup', up)
      }
    }
  }
}
</script>

<style>
.read_img {
  width: 11.947rem;
}

.bzcss {
  position: absolute;
}

.edit {
  position: relative;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/com/imagePage.vue